// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PerformanceFranquias_TabelaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/performance_franquias/buscaDadosTabela.
 *
 * The model issues `SELECT *` from a per-user materialised view
 * `vw_lista_performance_franquias_<userIdSansHyphens>`. Each row carries the
 * three fixed columns `franquia_id` (int), `franquia` (franchise name, string)
 * and `total_periodo` (price) PLUS one price column per day in the active
 * filter range — those day columns are aliased
 * `total_agendado_dia(...) as '<label>'` where the label is a runtime
 * locale/date-formatted string built by
 * Performance_franquias_model::formataNomeColuna() (e.g. "Segunda - 15/01").
 * The day-column key set is data-driven (varies by filter range AND user
 * language), so the row is genuinely shape-erased — every value is a scalar
 * string|float|int (the franchise name, plus int/float/numeric-string prices),
 * but the keys can't be enumerated, so it stays Record<string, string|number>
 * and cannot be narrowed to a Row class. Same dynamic-pivot pattern as
 * RecebimentoOperadores_BuscaDadosResponse.
 *
 * @see Performance_franquias::buscaDadosTabela()
 * @see Performance_franquias_model::criaViewXcrudPerformance()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type PerformanceFranquias_TabelaResponseDados = Record<string, string | number>[];

export type PerformanceFranquias_TabelaResponse = ApiResponse<PerformanceFranquias_TabelaResponseDados>;

registerResponseContract('PerformanceFranquias_TabelaResponse', {})
